<template>
  <div class="accum-recharge" :class="type">
    <AppLang />
    <div class="main-title" :class="locale"></div>
    <div class="count-down" v-if="!state.showCountDown">
      <div class="count-down-title" :class="locale">
        {{ $t('accumRecharge.countDownTitle') }}
      </div>
      <div class="hours">{{ state.hours }}</div>
      <div class="colon">:</div>
      <div class="minutes">{{ state.minutes }}</div>
      <div class="colon">:</div>
      <div class="seconds">{{ state.seconds }}</div>
    </div>
    <ValidateUser />
    <Introduce />
    <Rewards @updateRewardList="updateRewardList" />
    <Rule />
    <RewardsTimes :rewardList="state.rewardList" />
    <AppFooter class="footer" />
    <ActFloat />
  </div>
</template>
<script setup>
import { reactive } from 'vue'
import { isMobile } from '@/utils'
import AppLang from '@/components/AppLang'
import ValidateUser from '@/components/ValidateUser/ActAccumRecharge'
import Introduce from '@/views/act/accumRecharge/components/Introduce'
import Rewards from '@/views/act/accumRecharge/components/Rewards'
import Rule from '@/views/act/accumRecharge/components/Rule'
import RewardsTimes from '@/views/act/accumRecharge/components/RewardsTimes'
import AppFooter from '@/components/AppFooter'
import ActFloat from '@/views/act/accumRecharge/components/ActFloat'
import { useI18n } from 'vue-i18n'
const { locale } = useI18n()
const type = isMobile ? 'mobile' : 'pc'
const startTime = 1758211200000
const state = reactive({
  rewardList: [],
  showCountDown: false,
  hours: '00',
  minutes: '00',
  seconds: '00',
  timer: null
})

if (Date.now() >= startTime) {
  state.showCountDown = false
} else {
  state.showCountDown = true
}
const countDown = () => {
  const now = Date.now()
  if (now >= startTime) {
    clearInterval(state.timer)
    state.showCountDown = false
    return
  }
  const diff = startTime - now
  state.hours = Math.floor(diff / 1000 / 60 / 60).toString().padStart(2, '0')
  state.minutes = Math.floor(diff / 1000 / 60 % 60).toString().padStart(2, '0')
  state.seconds = Math.floor(diff / 1000 % 60).toString().padStart(2, '0')
}
countDown()
state.timer = setInterval(() => {
  countDown()
}, 1000)

const updateRewardList = (rewardList) => {
  state.rewardList = rewardList
}
</script>

<style src="./pc_style.less" lang="less" scoped></style>
<style src="./mobile_style.less" lang="less" scoped></style>
